import { ScaffoldSelection } from "../../interface";

/**
 * Returns whether the selection contains any selected cells, rows, or columns.
 *
 * @param selection - The scaffold selection state to check.
 * @returns True if at least one cell, row, or column is selected.
 */
export const hasAnySelection = (selection: ScaffoldSelection): boolean =>
  selection.selectedCells.length > 0 ||
  selection.selectedRows.length > 0 ||
  selection.selectedCols.length > 0;
